module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* Copyright 2018 Schibsted Products & Technology AS. Licensed under the terms of the MIT license.
 * See LICENSE.md in the project root.
 */



window.regeneratorRuntime = __webpack_require__(1);

var _require = __webpack_require__(3),
    Identity = _require.Identity;

module.exports = { Identity: Identity };

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      prototype[method] = function (arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction ||
    // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  exports.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function (arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function (error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
      // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
      // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);

    return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function () {
    return this;
  };

  Gp.toString = function () {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function (object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function stop() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;
}(
// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
( false ? undefined : _typeof(module)) === "object" ? module.exports : {});

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* Copyright 2018 Schibsted Products & Technology AS. Licensed under the terms of the MIT license.
 * See LICENSE.md in the project root.
 */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Identity = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _validate = __webpack_require__(4);

var _object = __webpack_require__(6);

var _url = __webpack_require__(7);

var _config = __webpack_require__(8);

var _tinyEmitter = __webpack_require__(9);

var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

var _JSONPClient = __webpack_require__(10);

var _JSONPClient2 = _interopRequireDefault(_JSONPClient);

var _cache = __webpack_require__(13);

var _cache2 = _interopRequireDefault(_cache);

var _popup = __webpack_require__(14);

var popup = _interopRequireWildcard(_popup);

var _ItpModal = __webpack_require__(15);

var _ItpModal2 = _interopRequireDefault(_ItpModal);

var _RESTClient = __webpack_require__(11);

var _RESTClient2 = _interopRequireDefault(_RESTClient);

var _SDKError = __webpack_require__(5);

var _SDKError2 = _interopRequireDefault(_SDKError);

var _spidTalk = __webpack_require__(16);

var spidTalk = _interopRequireWildcard(_spidTalk);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @typedef {object} Identity#HasSessionSuccessResponse
 * @property {boolean} result - Is the user connected to the merchant? (it means that the merchant
 * id is in the list of merchants listed of this user in the database)? Example: false
 * @property {string} userStatus - Example: 'notConnected' or 'connected'. Deprecated, use
 * `Identity.isConnected()`
 * @property {string} baseDomain - Example: 'localhost'
 * @property {string} id - Example: '58eca10fdbb9f6df72c3368f'. Obsolete
 * @property {number} userId - Example: 37162
 * @property {string} uuid - Example: 'b3b23aa7-34f2-5d02-a10e-5a3455c6ab2c'
 * @property {string} sp_id - Example: 'eyJjbGllbnRfaWQ...'
 * @property {number} expiresIn - Example: 30 * 60 * 1000 (for 30 minutes)
 * @property {number} serverTime - Example: 1506285759
 * @property {string} sig - Example: 'NCdzXaz4ZRb7...' The sig parameter is a concatenation of an
 * HMAC SHA-256 signature string, a dot (.) and a base64url encoded JSON object (session). @see
 * http://techdocs.spid.no/sdks/js/response-signature-and-validation/
 * @property {string} displayName - (Only for connected users) Example: 'batman'
 * @property {string} givenName - (Only for connected users) Example: 'Bruce'
 * @property {string} familyName - (Only for connected users) Example: 'Wayne'
 * @property {string} gender - (Only for connected users) Example: 'male', 'female', 'undisclosed'
 * @property {string} photo - (Only for connected users) Example:
 * 'http://www.srv.com/some/picture.jpg'
 * @property {boolean} tracking - (Only for connected users)
 * @property {boolean} clientAgreementAccepted - (Only for connected users)
 * @property {boolean} defaultAgreementAccepted - (Only for connected users)
 */

/**
 * Emitted when an error happens (useful for debugging)
 * @event Identity#error
 */

/**
 * @typedef {object} Identity#HasSessionFailureResponse
 * @property {object} error
 * @property {number} error.code - Typically an HTTP response code. Example: 401
 * @property {string} error.description - Example: "No session found!"
 * @property {string} error.type - Example: "UserException"
 * @property {object} response
 * @property {string} response.baseDomain - Example: "localhost"
 * @property {number} response.expiresIn - Time span in milliseconds. Example: 30 * 60 * 1000 (for 30 minutes)
 * @property {boolean} response.result
 * @property {number} response.serverTime - Server time in seconds since the Unix Epoch. Example: 1506287788
 */

/**
 * @typedef {object} Identity#SimplifiedLoginData
 * @property {string} identifier - Deprecated: User UUID, to be be used as `loginHint` for {@link Identity#login}
 * @property {string} display_text - Human-readable user identifier
 * @property {string} client_name - Client name
 */

var HAS_SESSION_CACHE_KEY = 'hasSession-cache';
var LOGIN_IN_PROGRESS_KEY = 'loginInProgress-cache';
var globalWindow = function globalWindow() {
    return window;
};

/**
 * Get type and value of something
 * @private
 * @param {string} thing
 * @returns {Array} Tuple of [type, value]
 */
function inspect(thing) {
    if (thing === null) {
        return [typeof thing === 'undefined' ? 'undefined' : _typeof(thing), '' + thing];
    }
    return [thing.constructor.name, thing.valueOf()];
}

/**
 * Provides Identity functionalty to a web page
 */

var Identity = exports.Identity = function (_EventEmitter) {
    _inherits(Identity, _EventEmitter);

    /**
     * @param {object} options
     * @param {string} options.clientId - Example: "1234567890abcdef12345678"
     * @param {string} [options.redirectUri] - Example: "https://site.com"
     * @param {string} [options.sessionDomain] - Example: "https://id.site.com"
     * @param {string} [options.env='PRE'] - Schibsted account environment: `PRE`, `PRO` or `PRO_NO`
     * @param {boolean} [options.siteSpecificLogout=true] - Whether site-specific logout should be used
     * @param {function} [options.log] - A function that receives debug log information. If not set,
     * no logging will be done
     * @throws {SDKError} - If any of options are invalid
     */
    function Identity(_ref) {
        var clientId = _ref.clientId,
            redirectUri = _ref.redirectUri,
            sessionDomain = _ref.sessionDomain,
            _ref$env = _ref.env,
            env = _ref$env === undefined ? 'PRE' : _ref$env,
            _ref$siteSpecificLogo = _ref.siteSpecificLogout,
            siteSpecificLogout = _ref$siteSpecificLogo === undefined ? true : _ref$siteSpecificLogo,
            log = _ref.log,
            _ref$window = _ref.window,
            window = _ref$window === undefined ? globalWindow() : _ref$window;

        _classCallCheck(this, Identity);

        var _this = _possibleConstructorReturn(this, (Identity.__proto__ || Object.getPrototypeOf(Identity)).call(this));

        (0, _validate.assert)((0, _validate.isNonEmptyString)(clientId), 'clientId parameter is required');
        (0, _validate.assert)((0, _validate.isObject)(window), 'The reference to window is missing');
        (0, _validate.assert)(!redirectUri || (0, _validate.isUrl)(redirectUri), 'redirectUri parameter is invalid');

        spidTalk.emulate(window);
        _this._sessionInitiatedSent = false;
        _this.window = window;
        _this.clientId = clientId;
        _this.cache = new _cache2.default(function () {
            return _this.window && _this.window.sessionStorage;
        });
        _this.redirectUri = redirectUri;
        _this.env = env;
        _this.siteSpecificLogout = siteSpecificLogout;
        _this.log = log;

        if (sessionDomain) {
            (0, _validate.assert)((0, _validate.isUrl)(sessionDomain), 'sessionDomain parameter is not a valid URL');
            _this._setSessionServiceUrl(sessionDomain);
        }

        // Internal hack: set to false to always refresh from hassession
        _this._enableSessionCaching = true;

        // Internal hack: set to true if the SDK is being used inside the ITP iframe to
        // avoid using the hasSession service and to prevent infinite iframe recursion
        _this._itpMode = false;

        // Old session
        _this._session = {};

        _this._setSpidServerUrl(env);
        _this._setBffServerUrl(env);
        _this._setOauthServerUrl(env);
        _this._setHasSessionServerUrl(env);
        _this._setGlobalSessionServiceUrl(env);
        return _this;
    }

    /**
     * Set SPiD server URL
     * @private
     * @param {string} url - real URL or 'PRE' style key
     * @returns {void}
     */


    _createClass(Identity, [{
        key: '_setSpidServerUrl',
        value: function _setSpidServerUrl(url) {
            (0, _validate.assert)((0, _validate.isStr)(url), 'url parameter is invalid: ' + url);
            this._spid = new _JSONPClient2.default({
                serverUrl: (0, _url.urlMapper)(url, _config.ENDPOINTS.SPiD),
                log: this.log,
                defaultParams: { client_id: this.clientId, redirect_uri: this.redirectUri }
            });
        }

        /**
         * Set OAuth server URL
         * @private
         * @param {string} url - real URL or 'PRE' style key
         * @returns {void}
         */

    }, {
        key: '_setOauthServerUrl',
        value: function _setOauthServerUrl(url) {
            (0, _validate.assert)((0, _validate.isStr)(url), 'url parameter is invalid: ' + url);
            this._oauthService = new _RESTClient2.default({
                serverUrl: (0, _url.urlMapper)(url, _config.ENDPOINTS.SPiD),
                log: this.log,
                defaultParams: { client_id: this.clientId, redirect_uri: this.redirectUri }
            });
        }

        /**
         * Set BFF server URL
         * @private
         * @param {string} url  - real URL or 'PRE' style key
         * @returns {void}
         */

    }, {
        key: '_setBffServerUrl',
        value: function _setBffServerUrl(url) {
            (0, _validate.assert)((0, _validate.isStr)(url), 'url parameter is invalid: ' + url);
            this._bffService = new _RESTClient2.default({
                serverUrl: (0, _url.urlMapper)(url, _config.ENDPOINTS.BFF),
                log: this.log,
                defaultParams: { client_id: this.clientId, redirect_uri: this.redirectUri }
            });
        }

        /**
         * Set site-specific session-service domain
         * @private
         * @param {string} domain - real URL — (**not** 'PRE' style env key)
         * @returns {void}
         */

    }, {
        key: '_setSessionServiceUrl',
        value: function _setSessionServiceUrl(domain) {
            (0, _validate.assert)((0, _validate.isStr)(domain), 'domain parameter is invalid: ' + domain);
            var client_sdrn = 'sdrn:' + _config.NAMESPACE[this.env] + ':client:' + this.clientId;
            this._sessionService = new _RESTClient2.default({
                serverUrl: domain,
                log: this.log,
                defaultParams: { client_sdrn: client_sdrn, redirect_uri: this.redirectUri }
            });
        }

        /**
         * Set global session-service server URL
         * @private
         * @param {string} url - real URL or 'PRE' style key
         * @returns {void}
         */

    }, {
        key: '_setGlobalSessionServiceUrl',
        value: function _setGlobalSessionServiceUrl(url) {
            (0, _validate.assert)((0, _validate.isStr)(url), 'url parameter is invalid: ' + url);
            var client_sdrn = 'sdrn:' + _config.NAMESPACE[this.env] + ':client:' + this.clientId;
            this._globalSessionService = new _RESTClient2.default({
                serverUrl: (0, _url.urlMapper)(url, _config.ENDPOINTS.SESSION_SERVICE),
                log: this.log,
                defaultParams: { client_sdrn: client_sdrn }
            });
        }

        /**
         * Set HasSession server URL - real URL or 'PRE' style key
         * @private
         * @param {string} url
         * @returns {void}
         */

    }, {
        key: '_setHasSessionServerUrl',
        value: function _setHasSessionServerUrl(url) {
            (0, _validate.assert)((0, _validate.isStr)(url), 'url parameter is invalid: ' + url);
            this._hasSession = new _JSONPClient2.default({
                serverUrl: (0, _url.urlMapper)(url, _config.ENDPOINTS.HAS_SESSION),
                log: this.log,
                defaultParams: { client_id: this.clientId, redirect_uri: this.redirectUri }
            });
        }

        /**
         * Emits the relevant events based on the previous and new reply from hassession
         * @private
         * @param {object} previous
         * @param {object} current
         * @returns {void}
         */

    }, {
        key: '_emitSessionEvent',
        value: function _emitSessionEvent(previous, current) {
            /**
             * Emitted when the user is logged in (This happens as a result of calling
             * {@link Identity#hasSession}, so it is also emitted if the user was previously logged in)
             * @event Identity#login
             */
            if (current.userId) {
                this.emit('login', current);
            }
            /**
             * Emitted when the user logged out
             * @event Identity#logout
             */
            if (previous.userId && !current.userId) {
                this.emit('logout', current);
            }
            /**
             * Emitted when the user is changed. This happens as a result of calling
             * {@link Identity#hasSession}, and is emitted if there was a user both before and after
             * this invocation, and the userId has now changed
             * @event Identity#userChange
             */
            if (previous.userId && current.userId && previous.userId !== current.userId) {
                this.emit('userChange', current);
            }
            if (previous.userId || current.userId) {
                /**
                 * Emitted when the session is changed. More accurately, this event is emitted if there
                 * was a logged-in user either before or after {@link Identity#hasSession} was called.
                 * In practice, this means the event is emitted a lot
                 * @event Identity#sessionChange
                 */
                this.emit('sessionChange', current);
            } else {
                /**
                 * Emitted when there is no logged-in user. More specifically, it means that there was
                 * no logged-in user neither before nor after {@link Identity#hasSession} was called
                 * @event Identity#notLoggedin
                 */
                this.emit('notLoggedin', current);
            }
            /**
             * Emitted when the session is first created
             * @event Identity#sessionInit
             */
            if (current.userId && !this._sessionInitiatedSent) {
                this._sessionInitiatedSent = true;
                this.emit('sessionInit', current);
            }
            /**
             * Emitted when the user status changes. This happens as a result of calling
             * {@link Identity#hasSession}
             * @event Identity#statusChange
             */
            if (previous.userStatus !== current.userStatus) {
                this.emit('statusChange', current);
            }
        }

        /**
         * Close this.popup if it exists and is open
         * @private
         * @returns {void}
         */

    }, {
        key: '_closePopup',
        value: function _closePopup() {
            if (this.popup) {
                if (!this.popup.closed) {
                    this.popup.close();
                }
                this.popup = null;
            }
        }

        /**
         * Set the Varnish cookie (`SP_ID`) when hasSession() is called. Note that most browsers require
         * that you are on a "real domain" for this to work — so, **not** `localhost`
         * @param {object} [options]
         * @param {number} [options.expiresIn] Override this to set number of seconds before the varnish
         * cookie expires. The default is to use the same time that hasSession responses are cached for
         * @param {boolean} [options.domain] Override cookie domain. E.g. «vg.no» instead of «www.vg.no»
         * @returns {void}
         */

    }, {
        key: 'enableVarnishCookie',
        value: function enableVarnishCookie(options) {
            var expiresIn = 0;
            var domain = void 0;
            if (Number.isInteger(options)) {
                expiresIn = options;
            } else if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) == 'object') {
                var _options$expiresIn = options.expiresIn;
                expiresIn = _options$expiresIn === undefined ? expiresIn : _options$expiresIn;
                var _options$domain = options.domain;
                domain = _options$domain === undefined ? domain : _options$domain;
            }

            (0, _validate.assert)(Number.isInteger(expiresIn), '\'expiresIn\' must be an integer');
            (0, _validate.assert)(expiresIn >= 0, '\'expiresIn\' cannot be negative');
            this.setVarnishCookie = true;
            this.varnishExpiresIn = expiresIn;
            this.varnishCookieDomain = domain;
        }

        /**
         * Set the Varnish cookie if configured
         * @private
         * @param {HasSessionSuccessResponse} sessionData
         * @returns {void}
         */

    }, {
        key: '_maybeSetVarnishCookie',
        value: function _maybeSetVarnishCookie(sessionData) {
            if (!this.setVarnishCookie) {
                return;
            }
            var date = new Date();
            var validExpires = this.varnishExpiresIn || typeof sessionData.expiresIn === 'number' && sessionData.expiresIn > 0;
            if (validExpires) {
                var expires = this.varnishExpiresIn || sessionData.expiresIn;
                date.setTime(date.getTime() + expires * 1000);
            } else {
                date.setTime(0);
            }

            // If the domain is missing or of the wrong type, we'll use document.domain
            var domain = this.varnishCookieDomain || (typeof sessionData.baseDomain === 'string' ? sessionData.baseDomain : document.domain) || '';

            var cookie = ['SP_ID=' + sessionData.sp_id, 'expires=' + date.toUTCString(), 'path=/', 'domain=.' + domain].join('; ');
            document.cookie = cookie;
        }

        /**
         * Clear the Varnish cookie if configured
         * @private
         * @returns {void}
         */

    }, {
        key: '_maybeClearVarnishCookie',
        value: function _maybeClearVarnishCookie() {
            if (this.setVarnishCookie) {
                this._clearVarnishCookie();
            }
        }

        /**
         * Clear the Varnish cookie
         * @private
         * @returns {void}
         */

    }, {
        key: '_clearVarnishCookie',
        value: function _clearVarnishCookie() {
            var domain = this.varnishCookieDomain || (this._session && typeof this._session.baseDomain === 'string' ? this._session.baseDomain : document.domain) || '';

            document.cookie = 'SP_ID=nothing; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.' + domain;
        }

        /**
         * Check if we need to use the ITP workaround for Safari versions >= 12
         * @private
         * @returns {boolean}
         */

    }, {
        key: '_itpModalRequired',
        value: function _itpModalRequired() {
            if (!document.requestStorageAccess || this._sessionService) {
                return false;
            }

            var safariVersion = navigator.userAgent.match(/Version\/(\d+)\./);
            if (!safariVersion || safariVersion.length < 2) {
                return false;
            }
            return parseInt(safariVersion[1], 10) >= 12;
        }

        /**
         * @summary Queries the hassession endpoint and returns information about the status of the user
         * @description When we send a request to this endpoint, cookies sent along with the request
         * determines the status of the user. If the user is not currently logged in, but has a cookie
         * with the "Remember me" flag switched on, calling this function will attempt to automatically
         * perform a login on the user
         * @param {boolean} [autologin=true] - Set this to `false` if you do **not** want the auto-login
         * to happen
         * @throws {SDKError} - If the call to the hasSession service fails in any way (this will happen
         * if, say, the user is not logged in)
         * @fires Identity#login
         * @fires Identity#logout
         * @fires Identity#userChange
         * @fires Identity#sessionChange
         * @fires Identity#notLoggedin
         * @fires Identity#sessionInit
         * @fires Identity#statusChange
         * @fires Identity#error
         * @return {Promise<Identity#HasSessionSuccessResponse|Identity#HasSessionFailureResponse>}
         */

    }, {
        key: 'hasSession',
        value: function hasSession() {
            var _this2 = this;

            var autologin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            if (this._hasSessionInProgress) {
                return this._hasSessionInProgress;
            }
            if (typeof autologin !== 'boolean') {
                var _inspect = inspect(autologin),
                    _inspect2 = _slicedToArray(_inspect, 2),
                    type = _inspect2[0],
                    value = _inspect2[1];

                return Promise.reject(new _SDKError2.default('Parameter \'autologin\' must be boolean, was: "' + type + ':' + value + '"'));
            }
            var _postProcess = function _postProcess(sessionData) {
                if (sessionData.error) {
                    throw new _SDKError2.default('HasSession failed', sessionData.error);
                }
                _this2._maybeSetVarnishCookie(sessionData);
                _this2._emitSessionEvent(_this2._session, sessionData);
                _this2._session = sessionData;
                return sessionData;
            };
            var _getSession = function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                    var cachedSession, sessionData, expiresIn, autoLoginConverted, shouldShowItpModal, modal, _expiresIn;

                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    if (!_this2._enableSessionCaching) {
                                        _context.next = 4;
                                        break;
                                    }

                                    // Try to resolve from cache (it has a TTL)
                                    cachedSession = _this2.cache.get(HAS_SESSION_CACHE_KEY);

                                    if (!cachedSession) {
                                        _context.next = 4;
                                        break;
                                    }

                                    return _context.abrupt('return', _postProcess(cachedSession));

                                case 4:
                                    sessionData = null;

                                    if (!_this2._sessionService) {
                                        _context.next = 19;
                                        break;
                                    }

                                    _context.prev = 6;
                                    _context.next = 9;
                                    return _this2._sessionService.get('/session');

                                case 9:
                                    sessionData = _context.sent;
                                    _context.next = 19;
                                    break;

                                case 12:
                                    _context.prev = 12;
                                    _context.t0 = _context['catch'](6);

                                    if (!_this2.siteSpecificLogout) {
                                        _context.next = 17;
                                        break;
                                    }

                                    if (_context.t0 && _context.t0.code === 400 && _this2._enableSessionCaching) {
                                        expiresIn = 1000 * (_context.t0.expiresIn || 300);

                                        _this2.cache.set(HAS_SESSION_CACHE_KEY, { error: _context.t0 }, expiresIn);
                                    }
                                    // Don't fallback to other sources for user session lookup
                                    throw _context.t0;

                                case 17:
                                    if (!(_context.t0.code !== 400)) {
                                        _context.next = 19;
                                        break;
                                    }

                                    throw _context.t0;

                                case 19:
                                    autoLoginConverted = autologin ? 1 : 0;

                                    if (!(!sessionData && !_this2._itpMode)) {
                                        _context.next = 24;
                                        break;
                                    }

                                    _context.next = 23;
                                    return _this2._hasSession.get('rpc/hasSession.js', { autologin: autoLoginConverted });

                                case 23:
                                    sessionData = _context.sent;

                                case 24:
                                    if (!(_this2._itpMode || sessionData && (0, _validate.isObject)(sessionData.error) && sessionData.error.type === 'LoginException')) {
                                        _context.next = 28;
                                        break;
                                    }

                                    _context.next = 27;
                                    return _this2._spid.get('ajax/hasSession.js', { autologin: autoLoginConverted });

                                case 27:
                                    sessionData = _context.sent;

                                case 28:
                                    shouldShowItpModal = _this2._itpModalRequired() && !_this2._itpMode && sessionData && (0, _validate.isObject)(sessionData.error) && sessionData.error.type === 'UserException' && _this2.cache.get(LOGIN_IN_PROGRESS_KEY) !== null;

                                    if (!shouldShowItpModal) {
                                        _context.next = 35;
                                        break;
                                    }

                                    _this2.cache.delete(LOGIN_IN_PROGRESS_KEY);
                                    modal = new _ItpModal2.default(_this2._spid, _this2.clientId, _this2.redirectUri, _this2.env);
                                    _context.next = 34;
                                    return modal.show();

                                case 34:
                                    sessionData = _context.sent;

                                case 35:
                                    if (sessionData && _this2._enableSessionCaching) {
                                        _expiresIn = 1000 * (sessionData.expiresIn || 300);

                                        _this2.cache.set(HAS_SESSION_CACHE_KEY, sessionData, _expiresIn);
                                    }
                                    return _context.abrupt('return', _postProcess(sessionData));

                                case 37:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2, [[6, 12]]);
                }));

                return function _getSession() {
                    return _ref2.apply(this, arguments);
                };
            }();
            this._hasSessionInProgress = _getSession().then(function (sessionData) {
                _this2._hasSessionInProgress = false;
                return sessionData;
            }, function (err) {
                _this2.emit('error', err);
                _this2._hasSessionInProgress = false;
                throw new _SDKError2.default('HasSession failed', err);
            });

            return this._hasSessionInProgress;
        }

        /**
         * @summary Allows the client app to check if the user is logged in to Schibsted account
         * @description This function calls {@link Identity#hasSession} internally and thus has the side
         * effect that it might perform an auto-login on the user
         * @return {boolean}
         */

    }, {
        key: 'isLoggedIn',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return this.hasSession();

                            case 3:
                                data = _context2.sent;
                                return _context2.abrupt('return', 'result' in data);

                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2['catch'](0);
                                return _context2.abrupt('return', false);

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[0, 7]]);
            }));

            function isLoggedIn() {
                return _ref3.apply(this, arguments);
            }

            return isLoggedIn;
        }()

        /**
         * Removes the cached user session.
         * @returns {void}
         */

    }, {
        key: 'clearCachedUserSession',
        value: function clearCachedUserSession() {
            this.cache.delete(HAS_SESSION_CACHE_KEY);
        }

        /**
         * @summary Allows the caller to check if the current user is connected to the client_id in
         * Schibsted account. Being connected means that the user has agreed for their account to be
         * used by your web app and have accepted the required terms
         * @description This function calls {@link Identity#hasSession} internally and thus has the side
         * effect that it might perform an auto-login on the user
         * @summary Check if the user is connected to the client_id
         * @return {boolean}
         */

    }, {
        key: 'isConnected',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;
                                _context3.next = 3;
                                return this.hasSession();

                            case 3:
                                data = _context3.sent;
                                return _context3.abrupt('return', !!data.result);

                            case 7:
                                _context3.prev = 7;
                                _context3.t0 = _context3['catch'](0);
                                return _context3.abrupt('return', false);

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[0, 7]]);
            }));

            function isConnected() {
                return _ref4.apply(this, arguments);
            }

            return isConnected;
        }()

        /**
         * @summary Returns information about the user
         * @description This function calls {@link Identity#hasSession} internally and thus has the side
         * effect that it might perform an auto-login on the user
         * @throws {SDKError} If the user isn't connected to the merchant
         * @throws {SDKError} If we couldn't get the user
         * @return {HasSessionSuccessResponse}
         */

    }, {
        key: 'getUser',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var user;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.hasSession();

                            case 2:
                                user = _context4.sent;

                                if (user.result) {
                                    _context4.next = 5;
                                    break;
                                }

                                throw new _SDKError2.default('The user is not connected to this merchant');

                            case 5:
                                return _context4.abrupt('return', (0, _object.cloneDeep)(user));

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function getUser() {
                return _ref5.apply(this, arguments);
            }

            return getUser;
        }()

        /**
         * @summary In Schibsted account, there are two ways of identifying a user; the `userId` and the
         * `uuid`. There are reasons for them both existing. The `userId` is a numeric identifier, but
         * since Schibsted account is deployed separately in Norway and Sweden, there are a lot of
         * duplicates. The `userId` was introduced early, so many sites still need to use them for
         * legacy reasons. The `uuid` is universally unique, and so — if we could disregard a lot of
         * Schibsted components depending on the numeric `userId` — it would be a good identifier to use
         * @description This function calls {@link Identity#hasSession} internally and thus has the side
         * effect that it might perform an auto-login on the user
         * @throws {SDKError} If the user isn't connected to the merchant
         * @return {string} The `userId` field (not to be confused with the `uuid`)
         */

    }, {
        key: 'getUserId',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var user;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.hasSession();

                            case 2:
                                user = _context5.sent;

                                if (!(user.userId && user.result)) {
                                    _context5.next = 5;
                                    break;
                                }

                                return _context5.abrupt('return', user.userId);

                            case 5:
                                throw new _SDKError2.default('The user is not connected to this merchant');

                            case 6:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function getUserId() {
                return _ref6.apply(this, arguments);
            }

            return getUserId;
        }()

        /**
         * @summary In Schibsted account, there are two ways of identifying a user; the `userId` and the
         * `uuid`. There are reasons for them both existing. The `userId` is a numeric identifier, but
         * since Schibsted account is deployed separately in Norway and Sweden, there are a lot of
         * duplicates. The `userId` was introduced early, so many sites still need to use them for
         * legacy reasons. The `uuid` is universally unique, and so — if we could disregard a lot of
         * Schibsted components depending on the numeric `userId` — it would be a good identifier to use
         * @description This function calls {@link Identity#hasSession} internally and thus has the side
         * effect that it might perform an auto-login on the user
         * @throws {SDKError} If the user isn't connected to the merchant
         * @return {string} The `uuid` field (not to be confused with the `userId`)
         */

    }, {
        key: 'getUserUuid',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var user;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.hasSession();

                            case 2:
                                user = _context6.sent;

                                if (!(user.uuid && user.result)) {
                                    _context6.next = 5;
                                    break;
                                }

                                return _context6.abrupt('return', user.uuid);

                            case 5:
                                throw new _SDKError2.default('The user is not connected to this merchant');

                            case 6:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function getUserUuid() {
                return _ref7.apply(this, arguments);
            }

            return getUserUuid;
        }()

        /**
         * @summary Get basic information about any user currently logged-in to their Schibsted account
         * in this browser. Can be used to provide context in a continue-as prompt.
         * @description This function relies on the global Schibsted account user session cookie, which
         * is a third-party cookie and hence might be blocked by the browser (for example due to ITP in
         * Safari). So there's no guarantee any data is returned, even though a user is logged-in in
         * the current browser.
         * @return {Identity#SimplifiedLoginData|null}
         */

    }, {
        key: 'getUserContextData',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.prev = 0;
                                _context7.next = 3;
                                return this._globalSessionService.get('/user-context');

                            case 3:
                                return _context7.abrupt('return', _context7.sent);

                            case 6:
                                _context7.prev = 6;
                                _context7.t0 = _context7['catch'](0);
                                return _context7.abrupt('return', null);

                            case 9:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this, [[0, 6]]);
            }));

            function getUserContextData() {
                return _ref8.apply(this, arguments);
            }

            return getUserContextData;
        }()

        /**
         * @summary Retrieve the sp_id (Varnish ID)
         * @description This function calls {@link Identity#hasSession} internally and thus has the side
         * effect that it might perform an auto-login on the user
         * @todo Is this an accurate description?
         * @return {string|null} - The sp_id string or null (if the server didn't return it)
         */

    }, {
        key: 'getSpId',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var user;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.prev = 0;
                                _context8.next = 3;
                                return this.hasSession();

                            case 3:
                                user = _context8.sent;
                                return _context8.abrupt('return', user.sp_id || null);

                            case 7:
                                _context8.prev = 7;
                                _context8.t0 = _context8['catch'](0);
                                return _context8.abrupt('return', null);

                            case 10:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this, [[0, 7]]);
            }));

            function getSpId() {
                return _ref9.apply(this, arguments);
            }

            return getSpId;
        }()

        /**
         * If a popup is desired, this function needs to be called in response to a user event (like
         * click or tap) in order to work correctly. Otherwise the popup will be blocked by the
         * browser's popup blockers and has to be explicitly authorized to be shown.
         * @summary Perform a login, either using a full-page redirect or a popup
         * @see https://tools.ietf.org/html/rfc6749#section-4.1.1
         * @param {object} options
         * @param {string} [options.acrValues] - Authentication Context Class Reference Values. If
         * omitted, the user will be asked to authenticate using username+password. 'otp-email' means
         * one time password using email. 'otp-sms' means one time password using sms
         * @param {string} options.state - An opaque value used by the client to maintain state between
         * the request and callback. It's also recommended to prevent CSRF
         * @see https://tools.ietf.org/html/rfc6749#section-10.12
         * @param {string} [options.scope='openid'] - The OAuth scopes for the tokens. This is a list of
         * scopes, separated by space. If the list of scopes contains `openid`, the generated tokens
         * includes the id token which can be useful for getting information about the user. Omitting
         * scope is allowed, while `invalid_scope` is returned when the client asks for a scope you
         * aren’t allowed to request.
         * @see https://tools.ietf.org/html/rfc6749#section-3.3
         * @param {string} [options.redirectUri=this.redirectUri] - Redirect uri that will receive the
         * code. Must exactly match a redirectUri from your client in self-service
         * @param {boolean} [options.preferPopup=false] - Should we try to open a popup window?
         * @param {boolean} [options.newFlow=true] - Should we try the new GDPR-safe flow or the
         * legacy/stable SPiD flow?
         * @param {string} [options.loginHint=''] - user email or UUID hint
         * @param {string} [options.tag=''] - Pulse tag
         * @param {string} [options.teaser=''] - Teaser slug. Teaser with given slug will be displayed
         * in place of default teaser
         * @param {number|string} [options.maxAge=''] - Specifies the allowable elapsed time in seconds since
         * the last time the End-User was actively authenticated. If last authentication time is more
         * than maxAge seconds in the past, re-authentication will be required. See the OpenID Connect
         * spec section 3.1.2.1 for more information
         * @param {string} [options.locale=''] - Optional parameter to overwrite client locale setting.
         * New flows supports nb_NO, fi_FI, sv_SE, en_US
         * @param {boolean} [options.oneStepLogin=false] - display username and password on one screen
         * @return {Window|null} - Reference to popup window if created (or `null` otherwise)
         */

    }, {
        key: 'login',
        value: function login(_ref10) {
            var acrValues = _ref10.acrValues,
                state = _ref10.state,
                _ref10$scope = _ref10.scope,
                scope = _ref10$scope === undefined ? 'openid' : _ref10$scope,
                _ref10$redirectUri = _ref10.redirectUri,
                redirectUri = _ref10$redirectUri === undefined ? this.redirectUri : _ref10$redirectUri,
                _ref10$preferPopup = _ref10.preferPopup,
                preferPopup = _ref10$preferPopup === undefined ? false : _ref10$preferPopup,
                _ref10$newFlow = _ref10.newFlow,
                newFlow = _ref10$newFlow === undefined ? true : _ref10$newFlow,
                _ref10$loginHint = _ref10.loginHint,
                loginHint = _ref10$loginHint === undefined ? '' : _ref10$loginHint,
                _ref10$tag = _ref10.tag,
                tag = _ref10$tag === undefined ? '' : _ref10$tag,
                _ref10$teaser = _ref10.teaser,
                teaser = _ref10$teaser === undefined ? '' : _ref10$teaser,
                _ref10$maxAge = _ref10.maxAge,
                maxAge = _ref10$maxAge === undefined ? '' : _ref10$maxAge,
                _ref10$locale = _ref10.locale,
                locale = _ref10$locale === undefined ? '' : _ref10$locale,
                _ref10$oneStepLogin = _ref10.oneStepLogin,
                oneStepLogin = _ref10$oneStepLogin === undefined ? false : _ref10$oneStepLogin;

            this._closePopup();
            this.cache.delete(HAS_SESSION_CACHE_KEY);
            var url = this.loginUrl({ state: state, acrValues: acrValues, scope: scope, redirectUri: redirectUri, newFlow: newFlow, loginHint: loginHint, tag: tag,
                teaser: teaser, maxAge: maxAge, locale: locale, oneStepLogin: oneStepLogin });

            this.showItpModalUponReturning();

            if (preferPopup) {
                this.popup = popup.open(this.window, url, 'Schibsted account', { width: 360, height: 570 });
                if (this.popup) {
                    return this.popup;
                }
            }
            this.window.location.href = url;
            return null;
        }

        /**
         * @summary Logs the user out from the Identity platform
         * @param {string} redirectUri - Where to redirect the browser after logging out of Schibsted
         * account
         * @return {void}
         */

    }, {
        key: 'logout',
        value: function logout() {
            var redirectUri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.redirectUri;

            this.cache.delete(HAS_SESSION_CACHE_KEY);
            this._maybeClearVarnishCookie();
            this.emit('logout');
            this.window.location.href = this.logoutUrl(redirectUri);
        }

        /**
         * Generates the link to the new login page that'll be used in the popup or redirect flow
         * @param {object} options
         * @param {string} options.state - An opaque value used by the client to maintain state between the
         * request and callback. It's also recommended to prevent CSRF.
         * @see https://tools.ietf.org/html/rfc6749#section-10.12
         * @param {string} [options.acrValues] - Authentication method. If omitted, user authenticates with
         * username+password. If set to `'otp-email'`, then  passwordless login using email is used. If
         * `'otp-sms'`, then passwordless login using sms is used. Please note that this parameter has
         * no effect if `newFlow` is false
         * @param {string} [options.scope='openid']
         * @param {string} [options.redirectUri=this.redirectUri]
         * @param {boolean} [options.newFlow=true] - Should we try the new flow or the old Schibsted account
         * login? If this parameter is set to false, the `acrValues` parameter doesn't have any effect
         * @param {string} [options.loginHint=''] - user email or UUID hint
         * @param {string} [options.tag=''] - Pulse tag
         * @param {string} [options.teaser=''] - Teaser slug. Teaser with given slug will be displayed
         * in place of default teaser
         * @param {number|string} [options.maxAge=''] - Specifies the allowable elapsed time in seconds since
         * the last time the End-User was actively authenticated. If last authentication time is more
         * than maxAge seconds in the past, re-authentication will be required. See the OpenID Connect
         * spec section 3.1.2.1 for more information
         * @param {string} [options.locale=''] - Optional parameter to overwrite client locale setting.
         * New flows supports nb_NO, fi_FI, sv_SE, en_US
         * @param {boolean} [options.oneStepLogin=false] - display username and password on one screen
         * @return {string} - The url
         */

    }, {
        key: 'loginUrl',
        value: function loginUrl(_ref11) {
            var state = _ref11.state,
                acrValues = _ref11.acrValues,
                _ref11$scope = _ref11.scope,
                scope = _ref11$scope === undefined ? 'openid' : _ref11$scope,
                _ref11$redirectUri = _ref11.redirectUri,
                redirectUri = _ref11$redirectUri === undefined ? this.redirectUri : _ref11$redirectUri,
                _ref11$newFlow = _ref11.newFlow,
                newFlow = _ref11$newFlow === undefined ? true : _ref11$newFlow,
                _ref11$loginHint = _ref11.loginHint,
                loginHint = _ref11$loginHint === undefined ? '' : _ref11$loginHint,
                _ref11$tag = _ref11.tag,
                tag = _ref11$tag === undefined ? '' : _ref11$tag,
                _ref11$teaser = _ref11.teaser,
                teaser = _ref11$teaser === undefined ? '' : _ref11$teaser,
                _ref11$maxAge = _ref11.maxAge,
                maxAge = _ref11$maxAge === undefined ? '' : _ref11$maxAge,
                _ref11$locale = _ref11.locale,
                locale = _ref11$locale === undefined ? '' : _ref11$locale,
                _ref11$oneStepLogin = _ref11.oneStepLogin,
                oneStepLogin = _ref11$oneStepLogin === undefined ? false : _ref11$oneStepLogin;

            if (_typeof(arguments[0]) !== 'object') {
                // backward compatibility
                state = arguments[0];
                acrValues = arguments[1];
                scope = arguments[2] || scope;
                redirectUri = arguments[3] || redirectUri;
                newFlow = typeof arguments[4] === 'boolean' ? arguments[4] : newFlow;
                loginHint = arguments[5] || loginHint;
                tag = arguments[6] || tag;
                teaser = arguments[7] || teaser;
                maxAge = isNaN(arguments[8]) ? maxAge : arguments[8];
            }
            (0, _validate.assert)(!acrValues || (0, _validate.isStrIn)(acrValues, ['', 'otp-email', 'otp-sms'], true), 'The acrValues parameter is not acceptable: ' + acrValues);
            (0, _validate.assert)((0, _validate.isUrl)(redirectUri), 'loginUrl(): redirectUri must be a valid url but is ' + redirectUri);
            (0, _validate.assert)((0, _validate.isNonEmptyString)(state), 'the state parameter should be a non empty string but it is ' + state);

            if (newFlow) {
                return this._oauthService.makeUrl('oauth/authorize', {
                    response_type: 'code',
                    'new-flow': true,
                    redirect_uri: redirectUri,
                    scope: scope,
                    state: state,
                    acr_values: acrValues,
                    login_hint: loginHint,
                    tag: tag,
                    teaser: teaser,
                    max_age: maxAge,
                    locale: locale,
                    one_step_login: oneStepLogin || '',
                    prompt: this.siteSpecificLogout ? 'select_account' : ''
                });
            } else {
                // acrValues do not work with the old flows
                return this._spid.makeUrl('flow/login', {
                    response_type: 'code',
                    redirect_uri: redirectUri,
                    scope: scope,
                    state: state,
                    email: loginHint,
                    tag: tag,
                    teaser: teaser,
                    locale: locale
                });
            }
        }

        /**
         * The url for logging the user out
         * @param {string} [redirectUri=this.redirectUri]
         * @return {string} url
         */

    }, {
        key: 'logoutUrl',
        value: function logoutUrl() {
            var redirectUri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.redirectUri;

            (0, _validate.assert)((0, _validate.isUrl)(redirectUri), 'logoutUrl(): redirectUri is invalid');
            var params = { redirect_uri: redirectUri };
            if (this._sessionService && this.siteSpecificLogout) {
                return this._sessionService.makeUrl('logout', params);
            }
            return this._spid.makeUrl('logout', Object.assign({ response_type: 'code' }, params));
        }

        /**
         * The account summary page url
         * @param {string} [redirectUri=this.redirectUri]
         * @return {string}
         */

    }, {
        key: 'accountUrl',
        value: function accountUrl() {
            var redirectUri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.redirectUri;

            return this._spid.makeUrl('account/summary', {
                response_type: 'code',
                redirect_uri: redirectUri
            });
        }

        /**
         * The phone editing page url
         * @param {string} [redirectUri=this.redirectUri]
         * @return {string}
         */

    }, {
        key: 'phonesUrl',
        value: function phonesUrl() {
            var redirectUri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.redirectUri;

            return this._spid.makeUrl('account/phones', {
                response_type: 'code',
                redirect_uri: redirectUri
            });
        }

        /**
         * Url to render either signup or login
         * @see https://techdocs.spid.no/flows/auth-flow/
         * @param {string} [redirectUri=this.redirectUri]
         * @return {string} - the url to the authentication page
         */

    }, {
        key: 'authFlowUrl',
        value: function authFlowUrl() {
            var redirectUri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.redirectUri;

            (0, _validate.assert)((0, _validate.isUrl)(redirectUri), 'authFlowUrl(): redirectUri is invalid');
            return this._spid.makeUrl('flow/auth', {
                response_type: 'code',
                redirect_uri: redirectUri
            });
        }

        /**
         * Url to render a signup view and let the user login with credentials
         * @see https://techdocs.spid.no/flows/auth-flow/
         * @param {string} [redirectUri=this.redirectUri]
         * @return {string} - the url to the signup page
         */

    }, {
        key: 'signupFlowUrl',
        value: function signupFlowUrl() {
            var redirectUri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.redirectUri;

            (0, _validate.assert)((0, _validate.isUrl)(redirectUri), 'signupFlowUrl(): redirectUri is invalid');
            return this._spid.makeUrl('flow/signup', {
                response_type: 'code',
                redirect_uri: redirectUri
            });
        }

        /**
         * To render a signin view and let the user login without credentials
         * @see https://techdocs.spid.no/flows/auth-flow/
         * @param {string} [redirectUri=this.redirectUri]
         * @return {string} - the url to the signin page
         */

    }, {
        key: 'signinFlowUrl',
        value: function signinFlowUrl() {
            var redirectUri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.redirectUri;

            (0, _validate.assert)((0, _validate.isUrl)(redirectUri), 'signinFlowUrl(): redirectUri is invalid');
            return this._spid.makeUrl('flow/signin', {
                response_type: 'code',
                redirect_uri: redirectUri
            });
        }

        /**
         * Call this method immediately before sending a user to a Schibsted account flow if you
         * want to enable showing of the ITP modal upon returning to your site. You should
         * send the user to a Schibsted account flow immediately after calling this method without
         * invoking hasSession() again.
         *
         * Calling this is not required if you send the user to Schibsted account via the login()
         * method.
         *
         * @return {void}
         */

    }, {
        key: 'showItpModalUponReturning',
        value: function showItpModalUponReturning() {
            // for safari, remember that we've got a login in progress so we can
            // work around some ITP issues when we come back from Schibsted Account
            if (this._itpModalRequired()) {
                this.cache.set(LOGIN_IN_PROGRESS_KEY, {}, 1000 * 60 * 15);
            }
        }

        /**
         * When returning after performing a flow, this method can be called prior to calling
         * hasSession() if you're certain that the user did not successfully log in. This will
         * prevent the ITP modal from showing up erroneously. If you're unsure, don't call this
         * method.
         *
         * @return {void}
         */

    }, {
        key: 'suppressItpModal',
        value: function suppressItpModal() {
            this.cache.delete(LOGIN_IN_PROGRESS_KEY);
        }

        /**
         * Function responsible for loading and displaying simplified login widget. How often
         * widget will be display is up to you. Preferred way would be to show it once per user,
         * and store that info in localStorage. Widget will be display only if user is logged in to SSO.
         *
         * @param {object} loginParams - the same as `options` param for login function. Login will be called on user
         * continue action. `state` might be string or async function.
         * @return {Promise<boolean|SDKError>} - will resolve to true if widget will be display. Otherwise will throw SDKError
         */

    }, {
        key: 'showSimplifiedLoginWidget',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(loginParams) {
                var _this3 = this;

                var userData, widgetUrl;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.getUserContextData();

                            case 2:
                                userData = _context10.sent;
                                widgetUrl = this._bffService.makeUrl('simplified-login-widget', { client_id: this.clientId }, false);
                                return _context10.abrupt('return', new Promise(function (resolve, reject) {
                                    if (!userData || !userData.display_text || !userData.identifier) {
                                        return reject(new _SDKError2.default('Missing user data'));
                                    }

                                    var initialParams = {
                                        displayText: userData.display_text,
                                        env: _this3.env,
                                        clientName: userData.client_name,
                                        clientId: _this3.clientId,
                                        providerId: userData.provider_id,
                                        windowWidth: function windowWidth() {
                                            return window.innerWidth;
                                        },
                                        windowOnResize: function windowOnResize(f) {
                                            window.onresize = f;
                                        }
                                    };

                                    var loginHandler = function () {
                                        var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                                            return regeneratorRuntime.wrap(function _callee9$(_context9) {
                                                while (1) {
                                                    switch (_context9.prev = _context9.next) {
                                                        case 0:
                                                            if (!(typeof loginParams.state === 'function')) {
                                                                _context9.next = 4;
                                                                break;
                                                            }

                                                            _context9.next = 3;
                                                            return loginParams.state();

                                                        case 3:
                                                            loginParams.state = _context9.sent;

                                                        case 4:
                                                            _this3.login(Object.assign(loginParams, { loginHint: userData.identifier }));

                                                        case 5:
                                                        case 'end':
                                                            return _context9.stop();
                                                    }
                                                }
                                            }, _callee9, _this3);
                                        }));

                                        return function loginHandler() {
                                            return _ref13.apply(this, arguments);
                                        };
                                    }();

                                    if (window.openSimplifiedLoginWidget) {
                                        window.openSimplifiedLoginWidget(initialParams, loginHandler);
                                        return resolve(true);
                                    }

                                    var simplifiedLoginWidget = document.createElement("script");
                                    simplifiedLoginWidget.type = "text/javascript";
                                    simplifiedLoginWidget.src = widgetUrl;
                                    simplifiedLoginWidget.onload = function () {
                                        window.openSimplifiedLoginWidget(initialParams, loginHandler);
                                        resolve(true);
                                    };
                                    simplifiedLoginWidget.onerror = function () {
                                        reject(new _SDKError2.default('Error when loading simplified login widget content'));
                                    };
                                    document.getElementsByTagName('body')[0].appendChild(simplifiedLoginWidget);
                                }));

                            case 5:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function showSimplifiedLoginWidget(_x9) {
                return _ref12.apply(this, arguments);
            }

            return showSimplifiedLoginWidget;
        }()
    }]);

    return Identity;
}(_tinyEmitter2.default);

exports.default = Identity;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* Copyright 2018 Schibsted Products & Technology AS. Licensed under the terms of the MIT license.
 * See LICENSE.md in the project root.
 */



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.assert = assert;
exports.isStr = isStr;
exports.isNonEmptyString = isNonEmptyString;
exports.isObject = isObject;
exports.isNonEmptyObj = isNonEmptyObj;
exports.isUrl = isUrl;
exports.isFunction = isFunction;
exports.isStrIn = isStrIn;

var _SDKError = __webpack_require__(5);

var _SDKError2 = _interopRequireDefault(_SDKError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * This module defines a set of validation functions which are used in the rest of the SDK.
 * Why make our own validation module?
 * 1. To implement the validations that we specifically need for the SDK
 * 2. To have one less dependency
 */

/**
 * A utility function that throws an SDKError if an assertion fails. It's mostly useful for
 * validating function inputs.
 * @memberof core
 * @param {boolean} condition - The condition that we're asserting
 * @param {string} [message = Assertion failed] - The error message
 * @throws {SDKError} - If the condition is falsy it throws the appropriate error
 * @return {void}
 */
function assert(condition) {
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Assertion failed';

    if (!condition) {
        throw new _SDKError2.default(message);
    }
}

/**
 * Checks if a value is a string or not
 * @memberof core
 * @param {*} value - The value to check
 * @return {boolean}
 */
function isStr(value) {
    return typeof value === 'string';
}

/**
 * Checks if a value is a non-empty string
 * @memberof core
 * @param {*} value - The value to check
 * @return {boolean}
 */
function isNonEmptyString(value) {
    return typeof value === 'string' && value.length > 0;
}

/**
 * checks if a given value is an object (but not null)
 * @memberof core
 * @param {*} value - The value to check
 * @return {boolean}
 */
function isObject(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null;
}

/**
 * Checks if a given value is an object with at least one own key
 * @memberof core
 * @param {*} value - The value to check
 * @return {boolean}
 */
function isNonEmptyObj(value) {
    return isObject(value) && Object.keys(value).length > 0;
}

/**
 * Checks if a given string is a valid URL
 * @memberof core
 * @param {string} value - The string to be tested
 * @param {...string} [mandatoryFields] - A list of mandatory fields that should exist in the parsed
 * URL object
 * @return {boolean}
 */
function isUrl(value) {
    try {
        var parsedUrl = new URL(value);

        for (var _len = arguments.length, mandatoryFields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            mandatoryFields[_key - 1] = arguments[_key];
        }

        return mandatoryFields.every(function (f) {
            return parsedUrl[f];
        });
    } catch (urlParsingError) {
        return false;
    }
}

/**
 * Checks if a given value is a function
 * @memberof core
 * @param {*} value - The value to check
 * @return {boolean}
 */
function isFunction(value) {
    return typeof value === 'function';
}

/**
 * Checks if a string matches any of the strings in a set of possibilities
 * @memberof core
 * @param {string} value
 * @param {string[]} possibilities - An array of strings that'll be used to check the string
 * inclusion. Note that for performance reasons, we don't validate this parameter.
 * @param {boolean} [caseSensitive=false] - Should the check be case sensitive
 * @return {boolean}
 */
function isStrIn(value, possibilities) {
    var caseSensitive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var _isSameStrCaseInsensitive = function _isSameStrCaseInsensitive(str) {
        return isStr(str) && value.toUpperCase() === str.toUpperCase();
    };
    if (!(isStr(value) && Array.isArray(possibilities))) {
        return false;
    }
    if (caseSensitive) {
        return possibilities.indexOf(value) !== -1;
    }
    return possibilities.some(_isSameStrCaseInsensitive);
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* Copyright 2018 Schibsted Products & Technology AS. Licensed under the terms of the MIT license.
 * See LICENSE.md in the project root.
 */



/*
 * Note: this module can't have any internal dependencies because it's used in ./validate which
 * in turn is used as a dependency to a lot of other modules. Doing so may create a circular
 * dependency that's hard to debug in Node.
 */

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var STRINGIFY_TYPES = ['boolean', 'number', 'string'];

/**
 * Represents a SDK error. This is returned from all rejected promises that are returned from an API
 * call. Constructs an SDK error ready to throw
 * @summary When the SDK throws an error, it's supposed to be an instance of this class
 * @private
 */

var SDKError = function (_Error) {
    _inherits(SDKError, _Error);

    /**
     * @property {number} code - The HTTP error code
     * @extends {Error}
     * @param {string} message - The error message
     * @param {object} [errorObject] - The error object that was returned from the server. Any
     * property of errorObject object will be copied into this instance SDKError
     */
    function SDKError(message, errorObject) {
        _classCallCheck(this, SDKError);

        var _this = _possibleConstructorReturn(this, (SDKError.__proto__ || Object.getPrototypeOf(SDKError)).call(this, message));

        _this.name = 'SDKError';
        if ((typeof errorObject === 'undefined' ? 'undefined' : _typeof(errorObject)) === 'object') {
            try {
                // At this point it doesn't matter if errorObject === null
                Object.assign(_this, errorObject);
            } catch (err) {
                // silent
            }
        }
        return _this;
    }

    /**
     * Serializes the error printing any interesting additional info
     * @private
     * @return {String}
     */


    _createClass(SDKError, [{
        key: 'toString',
        value: function toString() {
            var _this2 = this;

            var ret = this.name + ': ' + this.message;
            var additionalInfo = Object.keys(this).filter(function (key) {
                return key !== 'name' && STRINGIFY_TYPES.includes(_typeof(_this2[key]));
            }).map(function (key) {
                return '    ' + key + ': ' + _this2[key];
            }).join('\n');
            return additionalInfo ? ret + '\n' + additionalInfo : ret;
        }
    }]);

    return SDKError;
}(Error);

exports.default = SDKError;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* Copyright 2018 Schibsted Products & Technology AS. Licensed under the terms of the MIT license.
 * See LICENSE.md in the project root.
 */



/**
 * @summary Some routines that work on javascript objects
 * @private
 */

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.cloneDefined = cloneDefined;
exports.cloneDeep = cloneDeep;

var _validate = __webpack_require__(4);

var _SDKError = __webpack_require__(5);

var _SDKError2 = _interopRequireDefault(_SDKError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Similar to Object.assign({}, src) but only clones the keys of an object that have non-undefined
 * values.
 * Please note that the values in the rightmost parameters can overwrite the values of the earlier
 * parameters so the order of the parameters matters.
 * @memberof core
 * @example
 * cloneDefined({foo: 1, bar: 2}, {foo: 2}) // returns {foo: 2, bar: 2}
 *
 * @param {object} sources - one or more sources. Their defined properties will override the ones
 *        that came before it. For example if `source1.foo = 'bar'` and `source2.foo = 'baz'`, the
 *        result will include `{ foo: 'baz' }`
 * @return {object} a new object that is similar to src with all the key/values where the
 *         keys for undefined values are removed.
 */
function cloneDefined() {
    var dest = {};

    for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
        sources[_key] = arguments[_key];
    }

    if (!(sources && sources.length)) {
        throw new _SDKError2.default('No objects to clone');
    }
    sources.forEach(function (src) {
        (0, _validate.assert)((0, _validate.isObject)(src));
        if ((0, _validate.isNonEmptyObj)(src)) {
            Object.entries(src).forEach(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    key = _ref2[0],
                    val = _ref2[1];

                if (val !== undefined) {
                    // eslint-disable-line no-undefined
                    dest[key] = (0, _validate.isObject)(val) ? cloneDeep(val) : val;
                }
            });
        }
    });
    return dest;
}

/**
 * Deep copies an object. This is handy for immutability.
 * @memberof core
 * @param {object} obj - An object, array or null.
 * @return {object} - an exact copy of the object but deep copied
 * @throws {SDKError} - if the obj is not an accepted type or is not
 *         stringifiable by JSON for example if it has loops
 */
function cloneDeep(obj) {
    (0, _validate.assert)((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object', 'obj should be an object (even null) but it is ' + obj);
    return JSON.parse(JSON.stringify(obj)) || obj;
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* Copyright 2018 Schibsted Products & Technology AS. Licensed under the terms of the MIT license.
 * See LICENSE.md in the project root.
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.urlMapper = urlMapper;

var _validate = __webpack_require__(4);

/**
 * A simple utility function that allows looking up URLs from a dictionary
 * @memberof core
 * @param {string} url - A url like http://example.com, or a key used for lookup
 * @param {object<string,string>} urlMap - A map of URLs like
 * `{ DEV: 'http://dev.example.com' }`
 * @throws {SDKError} - If the url is not an string or is an empty string
 * @return {string} The url that points to the server
 */
function urlMapper(url, urlMap) {
  (0, _validate.assert)((0, _validate.isNonEmptyString)(url), '"url" param must be a non empty string: ' + (typeof url === 'undefined' ? 'undefined' : _typeof(url)));
  if ((0, _validate.isNonEmptyObj)(urlMap) && (0, _validate.isUrl)(urlMap[url])) {
    return urlMap[url];
  }
  (0, _validate.assert)((0, _validate.isUrl)(url, 'hostname'), 'Bad URL given: \'' + url + '\'');
  return url;
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* Copyright 2018 Schibsted Products & Technology AS. Licensed under the terms of the MIT license.
 * See LICENSE.md in the project root.
 */



/*
 * This file declares configs that are essentially part of how the SDK works and interacts with our
 * backend servers.
 *
 * What goes here?
 * - The configurations that are likely to change over time
 * - Constants that are otherwise obscure (for example 7000 for a TIMEOUT)
 *
 * What doesn't go here?
 * - options that the users of the SDK are supposed to set or provide as a parameter to functions
 *   and classes.
 */

/**
 * Core configuration used by the SDK
 * @type {Object}
 * @memberof core
 * @prop {object} ENDPOINTS - URL to some of the services that users of this SDK may interact with
 * @prop {object} ENDPOINTS.SPiD - SPiD endpoints
 * @prop {string} ENDPOINTS.SPiD.LOCAL - Local endpoint (for Identity team)
 * @prop {string} ENDPOINTS.SPiD.DEV - Dev environment (for Identity team)
 * @prop {string} ENDPOINTS.SPiD.PRE - Staging environment
 * @prop {string} ENDPOINTS.SPiD.PRO - Production environment Sweden
 * @prop {string} ENDPOINTS.SPiD.PRO_NO - Production environment Norway
 * @prop {object} ENDPOINTS.HAS_SESSION - Endpoints to check whether a user has a valid session
 * @prop {string} ENDPOINTS.HAS_SESSION.LOCAL - Local endpoint (for Identity team)
 * @prop {string} ENDPOINTS.HAS_SESSION.DEV - Dev environment (for Identity team)
 * @prop {string} ENDPOINTS.HAS_SESSION.PRE - Staging environment
 * @prop {string} ENDPOINTS.HAS_SESSION.PRO - Production environment Sweden
 * @prop {string} ENDPOINTS.HAS_SESSION.PRO_NO - Production environment Norway
 * @prop {object} ENDPOINTS.BFF - Endpoints used with new GDPR-compliant web flows
 * @prop {string} ENDPOINTS.BFF.LOCAL - Local endpoint (for Identity team)
 * @prop {string} ENDPOINTS.BFF.DEV - Dev environment (for Identity team)
 * @prop {string} ENDPOINTS.BFF.PRE - Staging environment
 * @prop {string} ENDPOINTS.BFF.PRO - Production environment Sweden
 * @prop {string} ENDPOINTS.BFF.PRO_NO - Production environment Norway
 * @prop {object} ENDPOINTS.SESSION_SERVICE - Endpoints to check global user session data
 * @prop {string} ENDPOINTS.SESSION_SERVICE.LOCAL - Local endpoint (for Identity team)
 * @prop {string} ENDPOINTS.SESSION_SERVICE.DEV - Dev environment (for Identity team)
 * @prop {string} ENDPOINTS.SESSION_SERVICE.PRE - Staging environment
 * @prop {string} ENDPOINTS.SESSION_SERVICE.PRO - Production environment Sweden
 * @prop {string} ENDPOINTS.SESSION_SERVICE.PRO_NO - Production environment Norway
 * @prop {object} JSONP
 * @prop {Number} JSONP.TIMEOUT=7000 - Timeout in milliseconds
 */

Object.defineProperty(exports, "__esModule", {
    value: true
});
var config = {
    ENDPOINTS: {
        SPiD: {
            LOCAL: 'http://id.localhost',
            DEV: 'https://identity-dev.schibsted.com',
            PRE: 'https://identity-pre.schibsted.com',
            PRO: 'https://login.schibsted.com',
            PRO_NO: 'https://payment.schibsted.no'
        },
        HAS_SESSION: {
            LOCAL: 'http://session.id.localhost',
            DEV: 'https://session.identity-dev.schibsted.com',
            PRE: 'https://session.identity-pre.schibsted.com',
            PRO: 'https://session.login.schibsted.com',
            PRO_NO: 'https://session.payment.schibsted.no'
        },
        BFF: {
            LOCAL: 'http://id.localhost/authn/',
            DEV: 'https://identity-dev.schibsted.com/authn/',
            PRE: 'https://identity-pre.schibsted.com/authn/',
            PRO: 'https://login.schibsted.com/authn/',
            PRO_NO: 'https://payment.schibsted.no/authn/'
        },
        SESSION_SERVICE: {
            LOCAL: 'http://session-service.id.localhost',
            DEV: 'https://session-service.identity-dev.schibsted.com',
            PRE: 'https://session-service.identity-pre.schibsted.com',
            PRO: 'https://session-service.login.schibsted.com',
            PRO_NO: 'https://session-service.payment.schibsted.no'
        }
    },
    JSONP: { TIMEOUT: 7000 }, // ms
    NAMESPACE: {
        LOCAL: 'id.localhost',
        DEV: 'schibsted.com',
        PRE: 'schibsted.com',
        PRO: 'schibsted.com',
        PRO_NO: 'spid.no'
    }
};

exports.default = config;
var ENDPOINTS = exports.ENDPOINTS = config.ENDPOINTS;
var JSONP = exports.JSONP = config.JSONP;
var NAMESPACE = exports.NAMESPACE = config.NAMESPACE;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function E() {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function on(name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function once(name, callback, ctx) {
    var self = this;
    function listener() {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback;
    return this.on(name, listener, ctx);
  },

  emit: function emit(name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function off(name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    liveEvents.length ? e[name] = liveEvents : delete e[name];

    return this;
  }
};

module.exports = E;
module.exports.TinyEmitter = E;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* Copyright 2018 Schibsted Products & Technology AS. Licensed under the terms of the MIT license.
 * See LICENSE.md in the project root.
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _object = __webpack_require__(6);

var _RESTClient2 = __webpack_require__(11);

var _RESTClient3 = _interopRequireDefault(_RESTClient2);

var _config = __webpack_require__(8);

var _config2 = _interopRequireDefault(_config);

var _fetchJsonp = __webpack_require__(12);

var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * To enable communication with JSONP endpoints
 * @memberof core
 * @private
 */
var JSONPClient = function (_RESTClient) {
  _inherits(JSONPClient, _RESTClient);

  /**
   * @param {object} options - See the `options` parameter of {@link RESTClient#constructor}
   * @param {number} [options.timeout=7000] - Timeout for fetch requests in milliseconds
   * @throws {SDKError} - when validating the options
   */
  function JSONPClient(options) {
    _classCallCheck(this, JSONPClient);

    var _this = _possibleConstructorReturn(this, (JSONPClient.__proto__ || Object.getPrototypeOf(JSONPClient)).call(this, (0, _object.cloneDefined)({ fetch: _fetchJsonp2.default }, options)));

    _this.timeout = options.timeout ? Number(options.timeout) : _config2.default.JSONP.TIMEOUT;
    return _this;
  }

  /**
   * Makes the actual call to the server and deals with headers, data objects and the edge cases
   * @private
   * @override
   * @param {object} options
   * @param {string} options.method - Currently it can only be 'GET' (case sensitive)
   * @param {string} options.pathname - The path to the endpoint like 'api/2/endpoint-name'
   * @param {object} [options.data={}] - Data payload (sent as query string)
   * @throws {SDKError} - If the call can't be invoked
   * @return {Promise} - A promise that will represent the success or failure of the call
   */


  _createClass(JSONPClient, [{
    key: 'go',
    value: function go() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { method: 'get', pathname: '/' };

      var fetchOptions = {
        method: options.method,
        credentials: 'include',
        timeout: this.timeout
      };
      return _get(JSONPClient.prototype.__proto__ || Object.getPrototypeOf(JSONPClient.prototype), 'go', this).call(this, Object.assign({ fetchOptions: fetchOptions }, options));
    }
  }]);

  return JSONPClient;
}(_RESTClient3.default);

exports.default = JSONPClient;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* Copyright 2018 Schibsted Products & Technology AS. Licensed under the terms of the MIT license.
 * See LICENSE.md in the project root.
 */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RESTClient = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SDKError = __webpack_require__(5);

var _SDKError2 = _interopRequireDefault(_SDKError);

var _object = __webpack_require__(6);

var _url = __webpack_require__(7);

var _validate = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Converts a series of parameters of various types to a string that's suitable for logging.
 * @private
 * @param {Array.<*>} msg - a number of parameters from any type (including objects)
 * @return {string}
 */
var logString = function logString(msg) {
    return msg.map(function (m) {
        return (0, _validate.isObject)(m) ? JSON.stringify(m, null, 2) : m;
    }).join(' ');
};

/**
 * Calls a log function passing a string
 * @private
 * @param {function} fn - the log function
 * @param {...*} msg - a series of message objects
 * @return {*} - The result of calling fn
 */
var logFn = function logFn(fn) {
    for (var _len = arguments.length, msg = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        msg[_key - 1] = arguments[_key];
    }

    return typeof fn === 'function' && fn(logString(msg));
};

/**
 * Encode a string like URLSearchParams would do
 * @private
 * @param {string} str - The input
 * @returns {string} The encoded string
 */
function encode(str) {
    var replace = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function (match) {
        return replace[match];
    });
}

var globalFetch = function globalFetch() {
    return window.fetch && window.fetch.bind(window);
};

/**
 * This class can be used for creating a wrapper around a server and all its endpoints.
 * Its functionality is extended by {@link JSONPClient}
 * Creates a client to a REST server. While useful stand-alone, it's also used for some other
 * types of client that change some functionalities.
 * @throws {SDKError} if any of options are invalid
 * @summary the simplest way to communicate to a REST endpoint without any
 *          special authentication
 * @memberof core
 * @private
 */

var RESTClient = exports.RESTClient = function () {

    /**
     * @param {object} options
     * @param {string} [options.serverUrl=PRE] - The URL to the server eg.
     * https://login.schibsted.com or a URL key like 'DEV' in combination with {@link envDic}.
     * @param {object} [options.envDic] - A dictionary that will be used for looking up
     * {@link serverUrl} keys. If serverUrl is always a URL, you don't need this.
     * @param {function} [options.fetch=window.fetch] - The fetch function to use. It can be native
     * or a polyfill
     * @param {function} [options.log] - A function that will be called with log messages about
     * request and response
     * @param {object} [options.defaultParams={}] - a set of parameters to add to every call custom.
     *        As long as it supports the standard fetch API we're good.
     */
    function RESTClient(_ref) {
        var _ref$serverUrl = _ref.serverUrl,
            serverUrl = _ref$serverUrl === undefined ? 'PRE' : _ref$serverUrl,
            envDic = _ref.envDic,
            _ref$fetch = _ref.fetch,
            fetch = _ref$fetch === undefined ? globalFetch() : _ref$fetch,
            log = _ref.log,
            _ref$defaultParams = _ref.defaultParams,
            defaultParams = _ref$defaultParams === undefined ? {} : _ref$defaultParams;

        _classCallCheck(this, RESTClient);

        (0, _validate.assert)((0, _validate.isObject)(defaultParams), 'defaultParams should be a non-null object');

        this.url = new URL((0, _url.urlMapper)(serverUrl, envDic));

        this.defaultParams = defaultParams;

        if (log) {
            (0, _validate.assert)((0, _validate.isFunction)(log), 'log must be a function but it is ' + log);
            this.log = log;
        }

        if (fetch) {
            (0, _validate.assert)((0, _validate.isFunction)(fetch), 'Fetch should be a function');
            this.fetch = fetch;
        }
    }

    /**
     * Makes the actual call to the server and deals with headers, data objects and the edge cases.
     * Please note that this method expects the response to be in JSON format. However, it'll not
     * parse the response if its code is not in the 200 range.
     * @param {object} options - an obligatory options object
     * @param {string} options.method - can be 'GET', 'POST', 'DELETE', etc. case sensitive.  To be
     *        more specific, this can be one of the values that are passed to the `methods`
     *        property of the constructor's `options` parameter.
     * @param {string} pathname - the path to the endpoint like 'api/2/endpoint-name'
     * @param {Object} [data={}] - data payload (depending on GET/DELETE or POST it may be a query
     *        string or form body)
     * @param {boolean} [useDefaultParams] - should we add the defaultParams to the query?
     * @throws {SDKError} - if the call can't be made for whatever reason.
     * @return {Promise<object>} - A promise that will resolve to the call's response or reject if there
     *         is an error before making the call or if the server returns a non-2xx error or
     *         something that's not parsable as JSON.
     */


    _createClass(RESTClient, [{
        key: 'go',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
                var method = _ref2.method,
                    headers = _ref2.headers,
                    pathname = _ref2.pathname,
                    _ref2$data = _ref2.data,
                    data = _ref2$data === undefined ? {} : _ref2$data,
                    _ref2$useDefaultParam = _ref2.useDefaultParams,
                    useDefaultParams = _ref2$useDefaultParam === undefined ? true : _ref2$useDefaultParam,
                    _ref2$fetchOptions = _ref2.fetchOptions,
                    fetchOptions = _ref2$fetchOptions === undefined ? { method: method, credentials: 'include' } : _ref2$fetchOptions;
                var fullUrl, response, responseObject, msg;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                (0, _validate.assert)((0, _validate.isFunction)(this.fetch), 'Can\'t make a call. The reference to fetch is missing or not a function.');
                                (0, _validate.assert)((0, _validate.isNonEmptyString)(method), 'Method must be a non empty string but it is "' + method + '"');
                                (0, _validate.assert)((0, _validate.isNonEmptyString)(pathname), 'Pathname must be string but it is "' + pathname + '"');
                                (0, _validate.assert)((0, _validate.isObject)(data), 'data must be a non-null object');

                                fetchOptions.headers = (0, _validate.isObject)(headers) ? (0, _object.cloneDefined)(headers) : {};
                                fullUrl = this.makeUrl(pathname, data, useDefaultParams);


                                logFn(this.log, 'Request:', fetchOptions.method.toUpperCase(), fullUrl);
                                logFn(this.log, 'Request Headers:', fetchOptions.headers);
                                logFn(this.log, 'Request Body:', fetchOptions.body);
                                _context.prev = 9;
                                _context.next = 12;
                                return this.fetch(fullUrl, fetchOptions);

                            case 12:
                                response = _context.sent;

                                logFn(this.log, 'Response Code:', response.status, response.statusText);

                                if (response.ok) {
                                    _context.next = 16;
                                    break;
                                }

                                throw new _SDKError2.default(response.statusText, { code: response.status });

                            case 16:
                                _context.next = 18;
                                return response.json();

                            case 18:
                                responseObject = _context.sent;

                                logFn(this.log, 'Response Parsed:', responseObject);
                                return _context.abrupt('return', responseObject);

                            case 23:
                                _context.prev = 23;
                                _context.t0 = _context['catch'](9);
                                msg = (0, _validate.isStr)(_context.t0) ? _context.t0 : 'Unknown RESTClient error';

                                if ((0, _validate.isObject)(_context.t0) && (0, _validate.isStr)(_context.t0.message)) {
                                    msg = _context.t0.message;
                                }
                                throw new _SDKError2.default('Failed to \'' + method + '\' \'' + fullUrl + '\': \'' + msg + '\'', _context.t0);

                            case 28:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[9, 23]]);
            }));

            function go(_x) {
                return _ref3.apply(this, arguments);
            }

            return go;
        }()

        /**
         * Creates a url that points to an endpoint in the server
         * @param {string} [pathname=] - WHATWG pathname ie. 'api/2/endpoint-name'
         * @param {object} [query={}] - WHATWG query. It's the data payload.
         * @param {boolean} [useDefaultParams=true] - should we add the defaultParams to the query?
         * @return {string} - the resulting url string ready to pass to fetch
         */

    }, {
        key: 'makeUrl',
        value: function makeUrl() {
            var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var useDefaultParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            var url = new URL(pathname, this.url);
            url.search = RESTClient.search(query, useDefaultParams, this.defaultParams);
            return url.href;
        }

        /**
         * Make a GET request
         * @param {string} pathname - WHATWG pathname ie. 'api/2/endpoint-name'
         * @param {object} [data={}] - the data payload.
         * @return {Promise}
         */

    }, {
        key: 'get',
        value: function get(pathname, data) {
            return this.go({ method: 'get', pathname: pathname, data: data });
        }

        /**
         * Construct query string for WHATWG urls
         * @private
         * @param {object} query - Object to generate query string from
         * @param {boolean} useDefaultParams - Use defaultParams or not
         * @param {object} defaultParams - Default params
         * @returns {string} Query string
         */

    }], [{
        key: 'search',
        value: function search(query, useDefaultParams, defaultParams) {
            var params = useDefaultParams ? (0, _object.cloneDefined)(defaultParams, query) : (0, _object.cloneDefined)(query);
            return Object.keys(params).filter(function (p) {
                return params[p] !== '';
            }).map(function (p) {
                return encode(p) + '=' + encode(params[p]);
            }).join('&');
        }
    }]);

    return RESTClient;
}();

exports.default = RESTClient;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(undefined, function (exports, module) {
  'use strict';

  var defaultOptions = {
    timeout: 5000,
    jsonpCallback: 'callback',
    jsonpCallbackFunction: null
  };

  function generateCallbackFunction() {
    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
  }

  function clearFunction(functionName) {
    // IE8 throws an exception when you try to delete a property on window
    // http://stackoverflow.com/a/1824228/751089
    try {
      delete window[functionName];
    } catch (e) {
      window[functionName] = undefined;
    }
  }

  function removeScript(scriptId) {
    var script = document.getElementById(scriptId);
    if (script) {
      document.getElementsByTagName('head')[0].removeChild(script);
    }
  }

  function fetchJsonp(_url) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    // to avoid param reassign
    var url = _url;
    var timeout = options.timeout || defaultOptions.timeout;
    var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;

    var timeoutId = undefined;

    return new Promise(function (resolve, reject) {
      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
      var scriptId = jsonpCallback + '_' + callbackFunction;

      window[callbackFunction] = function (response) {
        resolve({
          ok: true,
          // keep consistent with fetch API
          json: function json() {
            return Promise.resolve(response);
          }
        });

        if (timeoutId) clearTimeout(timeoutId);

        removeScript(scriptId);

        clearFunction(callbackFunction);
      };

      // Check if the user set their own params, and if not add a ? to start a list of params
      url += url.indexOf('?') === -1 ? '?' : '&';

      var jsonpScript = document.createElement('script');
      jsonpScript.setAttribute('src', '' + url + jsonpCallback + '=' + callbackFunction);
      if (options.charset) {
        jsonpScript.setAttribute('charset', options.charset);
      }
      jsonpScript.id = scriptId;
      document.getElementsByTagName('head')[0].appendChild(jsonpScript);

      timeoutId = setTimeout(function () {
        reject(new Error('JSONP request to ' + _url + ' timed out'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        window[callbackFunction] = function () {
          clearFunction(callbackFunction);
        };
      }, timeout);

      // Caught if got 404/500
      jsonpScript.onerror = function () {
        reject(new Error('JSONP request to ' + _url + ' failed'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        if (timeoutId) clearTimeout(timeoutId);
      };
    });
  }

  // export as global function
  /*
  let local;
  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }
  local.fetchJsonp = fetchJsonp;
  */

  module.exports = fetchJsonp;
});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* Copyright 2018 Schibsted Products & Technology AS. Licensed under the terms of the MIT license.
 * See LICENSE.md in the project root.
 */



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SDKError = __webpack_require__(5);

var _SDKError2 = _interopRequireDefault(_SDKError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Check whether we are able to use web storage
 * @param {Storage} storeProvider - A function to return a WebStorage instance (either
 * `sessionStorage` or `localStorage` from a `Window` object)
 * @private
 * @returns {boolean}
 */
function webStorageWorks(storeProvider) {
    if (!storeProvider) {
        return false;
    }
    try {
        var store = storeProvider();
        var randomKey = 'x-x-x-x'.replace(/x/g, function () {
            return Math.random();
        });
        var testValue = 'TEST-VALUE';
        store.setItem(randomKey, testValue);
        var val = store.getItem(randomKey);
        store.removeItem(randomKey);
        return val === testValue;
    } catch (e) {
        return false;
    }
}

/**
 * Will be used if web storage is available
 * @private
 */

var WebStorageCache =
/**
 * Create web storage cache object
 * @param {Storage} store - A reference to either `sessionStorage` or `localStorage` from a
 * `Window` object
 */
function WebStorageCache(store) {
    var _this = this;

    _classCallCheck(this, WebStorageCache);

    this.store = store;
    this.get = function (key) {
        return _this.store.getItem(key);
    };
    this.set = function (key, value) {
        return _this.store.setItem(key, value);
    };
    this.delete = function (key) {
        return _this.store.removeItem(key);
    };
};

/**
 * Will be used if session storage is not available
 * @private
 */


var LiteralCache =
/**
 * Create JS object literal cache object
 */
function LiteralCache() {
    var _this2 = this;

    _classCallCheck(this, LiteralCache);

    this.store = {};
    this.get = function (key) {
        return _this2.store[key];
    };
    this.set = function (key, value) {
        return _this2.store[key] = value;
    };
    this.delete = function (key) {
        return delete _this2.store[key];
    };
};

var maxExpiresIn = Math.pow(2, 31) - 1;

/**
 * Cache class that attempts WebStorage (session/local storage), and falls back to JS object literal
 * @private
 */

var Cache = function () {
    /**
     * @param {Storage} [storeProvider] - A function to return a WebStorage instance (either
     * `sessionStorage` or `localStorage` from a `Window` object)
     * @throws {SDKError} - If sessionStorage or localStorage are not accessible
     */
    function Cache(storeProvider) {
        _classCallCheck(this, Cache);

        if (webStorageWorks(storeProvider)) {
            this.cache = new WebStorageCache(storeProvider());
            this.type = 'WebStorage';
        } else {
            this.cache = new LiteralCache();
            this.type = 'ObjectLiteralStorage';
        }
    }

    /**
     * Get a value from cache (checks that the object has not expired)
     * @param {string} key
     * @private
     * @returns {*} - The value if it exists, otherwise null
     */


    _createClass(Cache, [{
        key: 'get',
        value: function get(key) {
            try {
                var raw = this.cache.get(key);
                var obj = raw ? JSON.parse(raw) : null;
                if (obj && Number.isInteger(obj.expiresOn) && obj.expiresOn > Date.now()) {
                    return obj.value;
                }
                this.delete(key);
                return null;
            } catch (e) {
                throw new _SDKError2.default(e);
            }
        }

        /**
         * Set a cache entry
         * @param {string} key
         * @param {*} value
         * @param {Number} expiresIn - Value in milliseconds until the entry expires
         * @private
         * @returns {void}
         */

    }, {
        key: 'set',
        value: function set(key, value) {
            var _this3 = this;

            var expiresIn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

            if (expiresIn <= 0) {
                return;
            }
            expiresIn = Math.min(maxExpiresIn, expiresIn);

            try {
                var expiresOn = Math.floor(Date.now() + expiresIn);
                this.cache.set(key, JSON.stringify({ expiresOn: expiresOn, value: value }));
                setTimeout(function () {
                    return _this3.delete(key);
                }, expiresIn);
            } catch (e) {
                throw new _SDKError2.default(e);
            }
        }

        /**
         * Delete a cache entry
         * @param {string} key
         * @private
         * @returns {void}
         */

    }, {
        key: 'delete',
        value: function _delete(key) {
            try {
                this.cache.delete(key);
            } catch (e) {
                throw new _SDKError2.default(e);
            }
        }
    }]);

    return Cache;
}();

exports.default = Cache;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.open = open;

var _validate = __webpack_require__(4);

var _object = __webpack_require__(6);

/**
 * Serializes an object to string.
 * @memberof core
 * @private
 * @param {object} obj - for example {a: 'b', c: 1}
 * @return {string} - for example 'a=b,c=1'
 */
/* Copyright 2018 Schibsted Products & Technology AS. Licensed under the terms of the MIT license.
 * See LICENSE.md in the project root.
 */

function serialize(obj) {
    (0, _validate.assert)((0, _validate.isObject)(obj), 'Object must be an object but it is \'' + obj + '\'');
    return Object.keys(obj).map(function (key) {
        return key + '=' + obj[key];
    }).join(',');
}

var defaultWindowFeatures = {
    scrollbars: 'yes',
    location: 'yes',
    status: 'no',
    menubar: 'no',
    toolbar: 'no',
    resizable: 'yes'
};

/**
 * Opens a popup
 * @param {Window} parentWindow - A reference to the window that will open the popup
 * @param {string} url - The URL that the popup will open
 * @param {string} [windowName] - A name for the window
 * @param {object} [windowFeatures] - Window features for the popup (default ones are usually ok)
 * @returns {Window|null} - A reference to the popup window
 * @private
 */
function open(parentWindow, url) {
    var windowName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var windowFeatures = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    (0, _validate.assert)((0, _validate.isObject)(parentWindow), 'window was supposed to be an object but it is ' + parentWindow);
    (0, _validate.assert)((0, _validate.isObject)(parentWindow.screen), 'window should be a valid Window object but it lacks a \'screen\' property');
    (0, _validate.assert)((0, _validate.isFunction)(parentWindow.open), 'window should be a valid Window object but it lacks an \'open\' function');
    (0, _validate.assert)((0, _validate.isUrl)(url), 'Invalid URL for popup');

    var _parentWindow$screen = parentWindow.screen,
        height = _parentWindow$screen.height,
        width = _parentWindow$screen.width;


    var mergedFeatures = (0, _object.cloneDefined)(defaultWindowFeatures, windowFeatures);
    if (Number.isFinite(mergedFeatures.width) && Number.isFinite(width)) {
        mergedFeatures.left = (width - mergedFeatures.width) / 2;
    }
    if (Number.isFinite(mergedFeatures.height) && Number.isFinite(height)) {
        mergedFeatures.top = (height - mergedFeatures.height) / 2;
    }
    var features = serialize(mergedFeatures);
    return parentWindow.open(url, windowName, features);
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.eventValidatorFunc = eventValidatorFunc;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FADE_DURATION_MS = 500;

/**
 * Standard validator for events
 * @private
 * @param {ItpModal} itpModal
 * @param {Event} event
 * @returns {Boolean}
 */
function eventValidatorFunc(itpModal, event) {
    return itpModal._iframeUrl.startsWith(event.origin) && event.data;
}

/**
 * A dialog that is shown after coming back from a login flow in the cases where
 * Schibsted Account is flagged as a tracking site by Apple ITP2.
 * @private
 */

var ItpModal = function () {
    /**
     * @param {JSONPClient} spid
     * @param {string} clientId
     * @param {string} redirectUri
     * @param {string} environment
     * @param {Function} eventValidator
     */
    function ItpModal(spid, clientId, redirectUri, environment) {
        var eventValidator = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : eventValidatorFunc;

        _classCallCheck(this, ItpModal);

        this._iframeUrl = spid.makeUrl('/authn/itp', {
            environment: environment,
            client_id: clientId,
            redirect_uri: redirectUri
        });
        this.isValidEvent = eventValidator;
    }

    /**
     * Show the ITP dialog
     * @private
     * @returns {Promise} resolves to the hasSession data
     */


    _createClass(ItpModal, [{
        key: 'show',
        value: function show() {
            var _this = this;

            return new Promise(function (resolve, reject) {
                _this._preventBodyScrolling();
                var modalEl = _this._buildModalElement();
                document.body.appendChild(modalEl);

                var closeModal = function closeModal() {
                    modalEl.style.opacity = 0;
                    window.removeEventListener('message', handlePostMessage);
                    setTimeout(function () {
                        document.body.removeChild(modalEl);
                        _this._restoreBodyScrolling();
                    }, FADE_DURATION_MS);
                };

                var handlePostMessage = function handlePostMessage(event) {
                    if (_this.isValidEvent(_this, event)) {
                        closeModal();
                        if (event.data.sessionData) {
                            resolve(event.data.sessionData);
                            return;
                        }
                        reject(event.data.error);
                    }
                };
                window.addEventListener('message', handlePostMessage);

                modalEl.onclick = function () {
                    closeModal();
                    reject('cancel');
                };

                // setTimeout is necessary because we need the element to be "mounted" in the DOM
                // with the old opacity (0) before setting the new opacity (1) or else we won't
                // get the CSS animation
                setTimeout(function () {
                    modalEl.style.opacity = 1;
                }, 0);
            });
        }

        /**
         * Create the DOM element containing the modal dialog
         * @private
         * @returns {DOMElement}
         */

    }, {
        key: '_buildModalElement',
        value: function _buildModalElement() {
            var modalEl = document.createElement('div');
            modalEl.style = this._buildStyleString({
                position: 'fixed',
                display: 'flex',
                'flex-direction': 'column',
                'align-items': 'center',
                'justify-content': 'center',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                'background-color': 'rgba(0, 0, 0, .7)',
                'transition': 'opacity ' + FADE_DURATION_MS + 'ms',
                opacity: 0,
                'z-index': 10000
            });

            var iframeEl = document.createElement('iframe');
            iframeEl.sandbox = 'allow-storage-access-by-user-activation allow-same-origin allow-scripts';
            iframeEl.style = this._buildStyleString({
                width: '368px',
                height: '400px',
                'background-color': '#ffffff'
            });
            iframeEl.src = this._iframeUrl;
            modalEl.appendChild(iframeEl);
            return modalEl;
        }

        /**
         * @private
         * @param {object} style key value style properties
         * @returns {string} CSS style string
         */

    }, {
        key: '_buildStyleString',
        value: function _buildStyleString(style) {
            return Object.keys(style).reduce(function (result, key) {
                return result + ' ' + key + ': ' + style[key] + ';';
            }, '');
        }

        /**
         * Lock the page so it doesn't scroll under the dialog
         * @private
         * @returns {void}
         */

    }, {
        key: '_preventBodyScrolling',
        value: function _preventBodyScrolling() {
            this._originalBodyOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
        }

        /**
         * Restore body scrolling
         * @private
         * @returns {void}
         */

    }, {
        key: '_restoreBodyScrolling',
        value: function _restoreBodyScrolling() {
            document.body.style.overflow = this._originalBodyOverflow;
        }
    }]);

    return ItpModal;
}();

exports.default = ItpModal;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* Copyright 2018 Schibsted Products & Technology AS. Licensed under the terms of the MIT license.
 * See LICENSE.md in the project root.
 */



/**
 * A workaround for how Schibsted account handles JSONP calls in the browser
 * @private
 */

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.emulate = emulate;

var _validate = __webpack_require__(4);

/**
 * This is a workaround for making the old SPiD/hassession on JSONP APIs compatible with more common
 * JSONP convention where the callback function is expected to exist in the global object.
 *
 * How does it work?
 * =================
 * The old SPiD JSONP APIs relied on SPiD.Talk.response(callbackName, data) but fetch-jsonp merely
 * calls window[callbackName](data) which is more common practice. This module simply acts as an
 * adapter to modernize the old mechanism until we support CORS. To see how the SPiD solution works,
 * try to run a simple JSONP request or debug it in netowrk tab. This module will be removed when
 * CORS is supported.
 * @memberof core
 * @param {object} global - a reference to the global object
 * @return {void}
 */
function emulate(global) {
    if (global.SPiD === null || _typeof(global.SPiD) !== 'object') {
        global.SPiD = {};
    }
    if (global.SPiD.Talk === null || _typeof(global.SPiD.Talk) !== 'object') {
        global.SPiD.Talk = {};
    }
    if (!(0, _validate.isFunction)(global.SPiD.Talk.response)) {
        global.SPiD.Talk.response = function (callbackName, data) {
            return global[callbackName](data);
        };
    }
}

/***/ })
/******/ ]);
//# sourceMappingURL=identity.js.map